 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"default~src-app-admin-admin-module~src-app-client-client-module":"default~src-app-admin-admin-module~src-app-client-client-module","src-app-admin-admin-module":"src-app-admin-admin-module","src-app-client-client-module":"src-app-client-client-module","authereum-eec753f3-js":"authereum-eec753f3-js","balance-4fc65e37-js":"balance-4fc65e37-js","common":"common","alphawallet-ecbe3fb8-js":"alphawallet-ecbe3fb8-js","atoken-68fc48b8-js":"atoken-68fc48b8-js","binance-chain-wallet-aa88a766-js":"binance-chain-wallet-aa88a766-js","bitpie-a7acfe0e-js":"bitpie-a7acfe0e-js","coinbase-2f352b98-js":"coinbase-2f352b98-js","dcent-aad7ab41-js":"dcent-aad7ab41-js","detectedwallet-bb867b2e-js":"detectedwallet-bb867b2e-js","frame-a3f4e5a5-js":"frame-a3f4e5a5-js","huobiwallet-c20a3556-js":"huobiwallet-c20a3556-js","hyperpay-cb53c487-js":"hyperpay-cb53c487-js","imtoken-583e1e88-js":"imtoken-583e1e88-js","liquality-0adca826-js":"liquality-0adca826-js","meetone-10714292-js":"meetone-10714292-js","metamask-61289acd-js":"metamask-61289acd-js","mykey-7624970d-js":"mykey-7624970d-js","opera-b328ed05-js":"opera-b328ed05-js","opera-touch-269c38a9-js":"opera-touch-269c38a9-js","ownbit-b933af7e-js":"ownbit-b933af7e-js","status-b68b10b3-js":"status-b68b10b3-js","tokenpocket-3b49fdba-js":"tokenpocket-3b49fdba-js","tp-a68fd870-js":"tp-a68fd870-js","trust-3acde196-js":"trust-3acde196-js","wallet-io-4eff2b30-js":"wallet-io-4eff2b30-js","wallet-link-d1311bd5-js":"wallet-link-d1311bd5-js","xdefi-6bae8b0e-js":"xdefi-6bae8b0e-js","connect-987cd10e-js":"connect-987cd10e-js","default~cobovault-3953e88e-js~eth-lattice-keyring~ethereumjs-common~ethereumjs-tx~ethereumjs-util~hd~746d3476":"default~cobovault-3953e88e-js~eth-lattice-keyring~ethereumjs-common~ethereumjs-tx~ethereumjs-util~hd~746d3476","default~cobovault-3953e88e-js~keystone-a9b702b8-js":"default~cobovault-3953e88e-js~keystone-a9b702b8-js","cobovault-3953e88e-js":"cobovault-3953e88e-js","default~ethereumjs-common~ethereumjs-tx~keystone-a9b702b8-js~shapeshiftoss-hdwallet-keepkey-webusb":"default~ethereumjs-common~ethereumjs-tx~keystone-a9b702b8-js~shapeshiftoss-hdwallet-keepkey-webusb","default~eth-provider~keystone-a9b702b8-js":"default~eth-provider~keystone-a9b702b8-js","keystone-a9b702b8-js":"keystone-a9b702b8-js","index-834be3ed-js":"index-834be3ed-js","default~ensdomains-ensjs~eth-lattice-keyring~ledgerhq-hw-app-eth":"default~ensdomains-ensjs~eth-lattice-keyring~ledgerhq-hw-app-eth","ensdomains-ensjs":"ensdomains-ensjs","fortmatic-c3e3fb61-js":"fortmatic-c3e3fb61-js","gnosis-3bdbc36a-js":"gnosis-3bdbc36a-js","lattice-2ad35d74-js":"lattice-2ad35d74-js","ledger-bf7925f7-js":"ledger-bf7925f7-js","network-56504ea8-js":"network-56504ea8-js","portis-a96e7122-js":"portis-a96e7122-js","torus-15abe206-js":"torus-15abe206-js","trezor-695cab17-js":"trezor-695cab17-js","wallet-connect-4ef5c2c8-js":"wallet-connect-4ef5c2c8-js","default~authereum~providerEngine-7945c13d-js~toruslabs-torus-embed~walletconnect-web3-provider~walletlink":"default~authereum~providerEngine-7945c13d-js~toruslabs-torus-embed~walletconnect-web3-provider~walletlink","default~authereum~providerEngine-7945c13d-js~walletconnect-web3-provider~walletlink":"default~authereum~providerEngine-7945c13d-js~walletconnect-web3-provider~walletlink","default~authereum~eth-sig-util~providerEngine-7945c13d-js~walletconnect-web3-provider":"default~authereum~eth-sig-util~providerEngine-7945c13d-js~walletconnect-web3-provider","default~authereum~providerEngine-7945c13d-js~walletconnect-web3-provider":"default~authereum~providerEngine-7945c13d-js~walletconnect-web3-provider","default~authereum~walletconnect-web3-provider":"default~authereum~walletconnect-web3-provider","authereum":"authereum","providerEngine-7945c13d-js":"providerEngine-7945c13d-js","eth-provider":"eth-provider","walletlink":"walletlink","default~ethereumjs-tx~shapeshiftoss-hdwallet-keepkey-webusb":"default~ethereumjs-tx~shapeshiftoss-hdwallet-keepkey-webusb","hd-wallet-51018814-js":"hd-wallet-51018814-js","default~shapeshiftoss-hdwallet-core~shapeshiftoss-hdwallet-keepkey-webusb":"default~shapeshiftoss-hdwallet-core~shapeshiftoss-hdwallet-keepkey-webusb","shapeshiftoss-hdwallet-keepkey-webusb":"shapeshiftoss-hdwallet-keepkey-webusb","fortmatic":"fortmatic","gnosis-pm-safe-apps-provider":"gnosis-pm-safe-apps-provider","gnosis-pm-safe-apps-sdk":"gnosis-pm-safe-apps-sdk","eth-lattice-keyring":"eth-lattice-keyring","eth-sig-util":"eth-sig-util","default~ledgerhq-hw-app-eth~ledgerhq-hw-transport-webusb":"default~ledgerhq-hw-app-eth~ledgerhq-hw-transport-webusb","ledgerhq-hw-app-eth":"ledgerhq-hw-app-eth","ledgerhq-hw-transport-webusb":"ledgerhq-hw-transport-webusb","ledgerhq-hw-transport-u2f":"ledgerhq-hw-transport-u2f","portis-web3":"portis-web3","toruslabs-torus-embed":"toruslabs-torus-embed","trezor-connect":"trezor-connect","walletconnect-web3-provider":"walletconnect-web3-provider"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
